import React from 'react';
import { useNavigate } from 'react-router-dom';
import './ServicePage.css';

function Blockchain() {
  const navigate = useNavigate();
  return (
    <div className="service-page">
      <header className="service-header">
        <h1>Blockchain & Smart Contracts</h1>
        <p>Design and development of secure decentralized applications and smart contracts.</p>
      </header>
      <button className="back-button" onClick={() => navigate(-1)}>← Back</button>
      <div className="service-container">
        <section className="service-section">
          <h3>Services</h3>
          <ul>
            <li>Smart contract development & auditing</li>
            <li>Enterprise blockchain solutions</li>
            <li>Tokenization & identity systems</li>
          </ul>
        </section>

        <div className="service-cta">
          <a href="/contact">Request Blockchain Consultation</a>
        </div>
      </div>
    </div>
  );
}

export default Blockchain;
